import {all, fork} from "redux-saga/effects";
import sessionSaga from "./session";

function* RoleManagerSaga(){
  yield all([
    fork(sessionSaga),
  ])
}
export default RoleManagerSaga;
